import {createSlice} from '@reduxjs/toolkit'

export const loadingSendSlice = createSlice({
  name: 'loadingSend',
  initialState: '',
  reducers: {
    startLoadingSend: (state, payload) => payload.payload,
    stopLoadingSend: (state) => '',
  },
})

export const isLoadingSend = (state: any) => state.loadingSend

export const {startLoadingSend, stopLoadingSend} = loadingSendSlice.actions

export default loadingSendSlice.reducer
